export default "__VITE_ASSET__Cv5k9C0t__"